import React from 'react';
import { Group, Text } from '@mantine/core';

/**
 * Une option de `Select` en deux lignes : le libellé, et sous lui la précision
 * qui permet de choisir entre deux entrées au nom voisin — l'ancre d'un bloc,
 * l'adresse d'un lien de la banque.
 *
 * `hintOf` lit cette précision sur l'option ; rien affiché si elle est vide,
 * ce qui couvre l'option de repli d'une cible perdue. L'option **sélectionnée**
 * ne montre que le libellé : l'adresse vit déjà sous le sélecteur.
 */
export function renderOptionWithHint(hintOf) {
  return function OptionWithHint({ option }) {
    const hint = hintOf(option);
    return (
      <Group
        gap={2}
        wrap="nowrap"
        style={{ minWidth: 0, flexDirection: 'column', alignItems: 'flex-start' }}
      >
        <Text size="sm" lh={1.2} truncate>{option.label}</Text>
        {!!hint && <Text size="10px" c="dimmed" lh={1.2} truncate>{hint}</Text>}
      </Group>
    );
  };
}

/** Les liens de la banque : le nom, puis l'adresse exacte. */
export const renderWebLinkOption = renderOptionWithHint((option) => option.url);
